export default function Footer() {
  return (
    <footer className="bg-[#0f1420] border-t border-[#3b82f6]/10 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/de1d28f06a6d46e7b7740ea0cb3b85f9/6c034f3ae4b5cab658b4163946ad3240.png" 
                alt="Server Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold text-white">Windo5DJ</span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              En iyi Minecraft sunucu deneyimi için doğru adrestesiniz. Hemen katıl ve macerana başla!
            </p>
            <div className="flex space-x-3">
              <a href="https://discord.gg/7MzuPKd9SD" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center text-[#3b82f6] hover:bg-[#3b82f6] hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-discord-fill text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@Windo5DJ" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center text-[#3b82f6] hover:bg-[#3b82f6] hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center text-[#3b82f6] hover:bg-[#3b82f6] hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <a href="#hero" className="text-gray-400 hover:text-[#3b82f6] transition-colors text-sm cursor-pointer">Ana Sayfa</a>
              </li>
              <li>
                <a href="#server-info" className="text-gray-400 hover:text-[#3b82f6] transition-colors text-sm cursor-pointer">Sunucu Bilgileri</a>
              </li>
              <li>
                <a href="#features" className="text-gray-400 hover:text-[#3b82f6] transition-colors text-sm cursor-pointer">Özellikler</a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-400 hover:text-[#3b82f6] transition-colors text-sm cursor-pointer">Galeri</a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-[#3b82f6] transition-colors text-sm cursor-pointer">İletişim</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Oyun Modları</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">BoxPvP</li>
              <li className="text-gray-400 text-sm">Skyblock</li>
              <li className="text-gray-400 text-sm">PvP Arena</li>
              <li className="text-gray-400 text-sm">BedWars</li>
              <li className="text-gray-400 text-sm">SkyWars</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Destek</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Kurallar</li>
              <li className="text-gray-400 text-sm">SSS</li>
              <li className="text-gray-400 text-sm">Yardım Merkezi</li>
              <li className="text-gray-400 text-sm">Ban Kaldırma</li>
              <li className="text-gray-400 text-sm">Gizlilik Politikası</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#3b82f6]/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Windo5DJ Server. Tüm hakları saklıdır.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#3b82f6] transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
